export default {
    methods: {
        /**
         * Recupero e pusho le zone nel datalayer
         */
        SideBarEvents_drawZone(mapObject) {

            // Svuoto tutto prima di mostrare le zone
            this.SideBarEvents_eraseSearchShape();

            // Svuoto datalayer
            this.emptyDataLayer();

            // Mostro il loading dall'istanza principale
            this.$root.isLoading('loading-toast');

            // Effettuo la chiamata al server
            window.axios.get(process.env.MIX_BASE_URL + 'zone/comuni/geometry').then( res => {
                
                // Pusho le feature nel datalayer
                for( let item of res.data.features ) {
                    mapObject.data.addGeoJson(item);  
                    this.zone = true;
                }
                this.showZone = true;

                // Nascondo eventuali spinner
                this.$root.stopLoading();
            }).catch( error => {
                // Stoppo il loading
                this.$root.stopLoading();

                // Mostro alert
                this.$root.alertHttp('loading-toast', 'Problemi nel caricamento dati');

                // Setto a false il boolean showzone che controlla la label del menu
                this.showZone = false;
            })
        },

        /**
         * Elimino tutti i marker dalla mappa e svuoto l'array in binding con il gomponente gmarker
         * @param {*} markers 
         */
        SideBarEvents_deleteMarkers(markers) {
           
            //Loop through all the markers and remove
            for (var i = 0; i < markers.length; i++) {
                markers[i].setMap(null);
            }
            this.markers = [];
        },

         /**
         * Elimino le forme disegnate
         */
        SideBarEvents_eraseSearchShape(hide = null) {

            // Elimino i marker
            this.SideBarEvents_deleteMarkers(this.markers);

            // Chiudo la sidebar
            this.closeSideBar();

            // Elimino gli eventuali poligoni, cerchi o punti disegnati
            this.currentCircle.map(function(item) {
                item.setMap(null);
            })
            
            this.currentPolygon.map(function(item) {
                item.setMap(null);
            })

            // Svuoto datalayer
            this.emptyDataLayer();
           
            if(hide) {
                this.confirmbutton = false;
            }

            // Svuoto eventuli selezioni sulla form di ricerca
            $('#geojson').val(null);

            // Elimino l'eventuale GeoJson salvato
            this.dataResult = null;

            // Setto a false il boolean showzone che controlla la label del menu
            if(this.showZone) {
                this.showZone = false;
            }

        },

        
        /**
         * Disegno i Pins
         */
        SideBarEvents_drawPins(search) {
            // Mostro il loading dall'istanza principale
            this.$root.isLoading('loading-toast');

            const params = {
                geojson: search,
                is_map: true
            }

            // Effettuo la chiamata al server
            window.axios.post(process.env.MIX_BASE_URL + 'immobili/search', params).then( res => {

                // Elimino i marker precedenti per disegnarli ancora
                this.SideBarEvents_deleteMarkers(this.markers);

                // Creo un'array di marker da passare al componente gmapmarker
                this.GoogleMapDrawer_addMarker(res.data.data);

                // Nascondo eventuali spinner
                this.$root.stopLoading();
            }).catch( error => {
                // Stoppo il loading
                this.$root.stopLoading();

                // Mostro alert
                this.$root.alertHttp('loading-toast', 'Problemi nel caricamento dati');
            })
        },

    }
 }